export default {"src":"/_next/static/media/round-nerd-large.ee7c7109.svg","height":80,"width":80};